import { getPlatform } from './util'
import {
  IBaseInfo,
  IReportHandleParm,
  IClickGet,
  IBookGet,
  ICurrentGet,
  IErrorGet,
  IPayGet
} from './types'
import {
  reportInfo,
  decodeReportResponse
} from '../../services/reportInfoServices'

/** 3.5上报版本号 */
const VERSION = 'v1.0.0'

/** 基础信息获取 */
const baseInfo = () => {
  /** 上报的通用参数 */
  const reportInfo: IBaseInfo = {
    channel_id: 6,
    install_id: 0,
    run_id: 0,
    ctime: 0,
    netstatus: 0,
    platform: 0,
    uuid: '',
    language: '',
    version: VERSION,
    cversion: VERSION
  }
  if (!localStorage?.getItem('install_id')) {
    reportInfo.install_id = parseInt(
      ((Math.random() * 9 + 1) * 10000000).toString()
    )
    localStorage?.setItem('install_id', reportInfo.install_id.toString())
  } else {
    reportInfo.install_id = Number(localStorage?.getItem('install_id'))
  }

  if (!sessionStorage.getItem('run_id')) {
    reportInfo.run_id = parseInt(
      ((Math.random() * 9 + 1) * 10000000).toString()
    )
    sessionStorage.setItem('run_id', reportInfo.run_id.toString())
  } else {
    reportInfo.run_id = Number(sessionStorage.getItem('run_id'))
  }

  reportInfo.ctime = parseInt(String(new Date().getTime() / 1000))
  reportInfo.netstatus = 0
  reportInfo.platform = getPlatform()
  // 由于商城h5上报主要以sessionStorage为主所以调整
  reportInfo.uuid =
    sessionStorage.getItem('uid') || localStorage?.getItem('uid') || ''
  reportInfo.language = /* navigator.language; */ 'en'
  return reportInfo
}

/** click事件   eid=12 */
const clickGet = (obj: IClickGet) => {
  const click_get: IClickGet = {
    eid: 12,
    ...obj
  }

  return click_get
}
/** event_get事件   eid=13 */
const eventGet = (obj: IClickGet) => {
  const event_get: IClickGet = {
    eid: 13,
    ...obj
  }

  return event_get
}
/** currentGet事件   eid=5 */
const currentGetEvent = (obj: ICurrentGet) => {
  const click_get: ICurrentGet = {
    eid: 5,
    parm9: '1',
    parm5: '6',
    ...obj
  }

  return click_get
}

/** book_get书籍阅读相关事件上报 */
const bookGet = (obj: IBookGet) => {
  const book_get: IBookGet = {
    eid: 7,
    parm9: window.location.href,
    ...obj
  }

  return book_get
}

/** err_get错误事件上报 */
const errorGet = (obj: IErrorGet) => {
  const error_get: IErrorGet = {
    eid: 8,
    parm6: location.host,
    ...obj
  }
  return error_get
}

/** pay_get事件上报 */
const payGet = (obj: IPayGet) => {
  return {
    eid: 3,
    ...obj
  }
}

/** 发起上报函数 */
const reportInfoHandle = async (list: any, id?: number) => {
  const ctime: number = parseInt(String(new Date().getTime() / 1000))
  id = id || new Date().getTime()
  const { response, error } = await reportInfo({
    list,
    ctime
  })

  console.log(decodeReportResponse(response), response)
  // 解密响应结果
  let res
  try {
    res = response && JSON.parse(decodeReportResponse(response))
  } catch (error) {}
  // console.log('上报结果', res);
  // 如果上报失败
  if (error || !res || res?.error_code !== 0) {
    // console.log('存储的id为。。。', id);
    const local = JSON.parse(sessionStorage.getItem(String(id)) || '{}')
    const step = local.step || 1

    // 如果步长大于3就直接取消这次上报
    if (step > 3) {
      sessionStorage.removeItem(String(id))
      return 0
    }

    // 将上报信息存在本地
    sessionStorage.setItem(String(id), JSON.stringify({ list, step }))
    // console.log('重新上报id', id);
    setTimeout(() => {
      // 重新调用上报接口函数
      try {
        reportInfoHandle(
          JSON.parse(sessionStorage.getItem(String(id))!).list,
          id
        )
      } catch (error) {}
      // 步长加1
      sessionStorage.setItem(
        String(id),
        JSON.stringify({ list, step: step + 1 })
      )
    }, Math.pow(2, step) * 1000)
  } else {
    // 上报成功请求缓存
    sessionStorage.removeItem(String(id))
  }
  return response
}

/**
 * 处理上报参数函数
 * @param {IReportHandleParm | IReportHandleParm[]} objArr 可为对象或者包含对象的数组
 * @param { object } moreParams 额外的参数对象
 */
const reportHandle = async (
  objArr: IReportHandleParm | IReportHandleParm[],
  moreParams?: { [key: string]: any }
) => {
  const reportInfo = baseInfo()
  const list: any[] = []
  objArr = Array.isArray(objArr) ? objArr : [objArr]

  objArr.forEach((item: IReportHandleParm) => {
    let data: any
    switch (item.type) {
      case 7:
        data = bookGet(item.param as IBookGet)
        break
      case 5:
        data = currentGetEvent(item.param as ICurrentGet)
        break
      case 12:
        data = clickGet(item.param as IClickGet)
        break
      case 13:
        data = eventGet(item.param as IClickGet)
        break
      case 8:
        data = errorGet(item.param as IErrorGet)
        break
      case 3:
        data = payGet(item.param as IPayGet)
        break
    }
    Object.assign(data, reportInfo)
    list.push(data)
    console.log('上报信息', item.type, data)
  })

  // 调用上报接口函数
  reportInfoHandle(list)
}

export { reportHandle }
